import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import get from "lodash/get";
import map from "lodash/map";
import logoImage from "../../static/images/sochIOtLogo.jpeg";
import dayjs from "dayjs";
import { fetchImageAsBase64 } from '../images'

const companyDetails = (selectedTemplate, filter) => [
  {
    key: "Machine",
    value: get(selectedTemplate, "template.name"),
    suffix: 1.5,
    label: 1,
  },
  {
    key: "Company",
    value: get(filter, "company.name"),
    suffix: 1.5,
    label: 1,
  },
  {
    key: "Address",
    value: get(filter, "company.address"),
    suffix: 2,
    label: 1,
  },
];

const basicDetails = (selectedTemplate, filter) => [
  {
    key: "Date",
    value: get(filter, "date") ? get(filter, "date").format("DD/MM/YYYY") : "--",
    suffix: 1.5,
    label: 1,
  },
  {
    key: "Shift",
    value: get(filter, "shift.name") ? `${get(filter, "shift.name")} ${" "} (${dayjs(
      get(filter, "shift.start"),
      "HH:mm:ss"
    ).format("HH:mm")} - ${dayjs(
      get(filter, "shift.end"),
      "HH:mm:ss"
    ).format("HH:mm")})` : "--",
    suffix: 1.5,
    label: 1,
  },
];

const statsDetails = (selectedTemplate, templateType) => {
  switch (templateType) {
    case 1:
      [
        {
          key: "Cavity",
          value: `${get(selectedTemplate, "meta.cavity") || 0}`,
          // value: "1",
          label: 0.5,
          suffix: 0.5,
        },
        {
          key: "Availabilty Ratio",
          value: `${get(selectedTemplate, "calculated_stats.availablity_ratio") || 0}%`,
          label: 1.5,
          suffix: 0.5,
        },
        {
          key: "Operator Efficency",
          value: `${get(selectedTemplate, "calculated_stats.operator_efficiency") || 0}%`,
          label: 1.5,
          suffix: 0.5,
        },
        {
          key: "Machine Efficency",
          value: `${get(selectedTemplate, "calculated_stats.machine_efficiency") || 0}%`,
          label: 1.5,
          suffix: 0.5,
        },
        {
          key: "Quality Ratio",
          value: `${get(selectedTemplate, "calculated_stats.quality_ratio") || 0}%`,
          label: 1.2,
          suffix: 1,
        },
        {
          key: "OEE",
          value: `${get(selectedTemplate, "calculated_stats.oee") || 0}%`,
          label: 0.5,
          suffix: 0.5,
        },
      ]
    case 2:
      [
        {
          key: "Length",
          value: `${get(selectedTemplate, "meta.total_length") || 0}`,
          // value: "1",
          label: 0.5,
          suffix: 0.5,
        },
        {
          key: "Operator Efficency",
          value: `${get(selectedTemplate, "meta.operator_efficiency") || 0}%`,
          label: 1.5,
          suffix: 0.5,
        },
        {
          key: "Machine Efficency",
          value: `${get(selectedTemplate, "meta.machine_efficiency") || 0}%`,
          label: 1.5,
          suffix: 0.5,
        },
        {
          key: "Quality Ratio",
          value: `${get(selectedTemplate, "meta.quality_ratio") || 0}%`,
          label: 1.2,
          suffix: 1,
        },
        {
          key: "OEE",
          value: `${get(selectedTemplate, "meta.oee") || 0}%`,
          label: 0.5,
          suffix: 0.5,
        },
      ]
  }
};

const printLabel = (doc, value, x, y) => {
  doc.setTextColor(0, 0, 0);
  doc.text(value, x, y, { angle: 90 });
};

const printValue = (doc, value, x, y) => {
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica',"bold");
  doc.text(value, x, y, { angle: 90 });
};

const renderStatsRow = (doc, statsDetails, yOffset, xOffset) => {
  map(statsDetails, (arr, i) => {
    printLabel(doc, `${get(arr, "key")} : `, xOffset, yOffset);
    yOffset = yOffset - 20 * get(arr, "label");
    printValue(doc, get(arr, "value"), xOffset, yOffset);
    yOffset = yOffset - 30 * get(arr, "suffix");
  });
};

export const generateInjectionMouldingTimeGraphPdf = async (
  selectedTemplate,
  filter,
  setLoading,
  fileName
) => {
  try {
    setLoading(true);
    const doc = new jsPDF({ format: "a4", compress: true });
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Define section widths
    const firstSectionWidth = pageWidth * 0.2; // 20% of the width
    const secondSectionWidth = pageWidth * 0.8; // 80% of the width

    let yOffset = 2;
    let xOffset = 2;
    const logoWidth = firstSectionWidth - 10;
    const logoHeight = logoWidth * 0.6;

    if (get(filter, "company.logo.key")) {
      doc.addImage(logoImage, "PNG", xOffset, yOffset, logoWidth, logoHeight);
      yOffset += logoHeight;
      let logoBase64 = await fetchImageAsBase64(
        get(filter, "company.logo.key")
      );
      doc.addImage(logoBase64, "PNG", xOffset, yOffset, logoWidth, logoHeight);
    } else {
      doc.addImage(logoImage, "PNG", xOffset, yOffset, logoWidth, logoHeight);
    }

    // Render statistics
    yOffset = pageHeight - 10;
    renderStatsRow(doc, companyDetails(selectedTemplate, filter), yOffset, 8);
    renderStatsRow(doc, basicDetails(selectedTemplate, filter), yOffset, 18);
    renderStatsRow(doc, statsDetails(selectedTemplate, get(filter, "templateType")), yOffset, 28);

    // Fetch graphs
    const graphContainers = document.querySelectorAll(".graph-container");
    const totalGraphs = graphContainers.length;

    yOffset = 10;
    const availableHeight = pageHeight - 2; // Leave space for header/footer
    const graphWidth = secondSectionWidth - 5;
    const graphHeight = availableHeight / totalGraphs - 5; // Divide space equally

 for (let i = 0; i < totalGraphs; i++) {
  const graphContainer = graphContainers[i];

  await new Promise(res => setTimeout(res, 300));

  const graphCanvas = await html2canvas(graphContainer, {
    useCORS: true,
    scale: 2,
    backgroundColor: null,
  });

  const graphImgData = graphCanvas.toDataURL("image/png");

  const scaledGraphHeight = Math.min(
    (graphCanvas.height * graphWidth) / graphCanvas.width,
    graphHeight
  );

  doc.addImage(
    graphImgData,
    "PNG",
    firstSectionWidth,
    yOffset,
    graphWidth,
    scaledGraphHeight
  );

  yOffset += scaledGraphHeight + 2;
}


    doc.save(`${fileName}`);
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    setLoading(false);
  }
};
